export const selector = 'dbAOnBlur';

/* @ngInject */
export default function OnBlurDirective() {
    return {
        restrict: 'A',

        link(scope, element, attrs) {
            element.on('blur', blurHandler);
            scope.$on('$destroy', () => element.off('blur', blurHandler));

            function blurHandler() {
                scope.$applyAsync(() => scope.$eval(attrs[selector]));
            }
        }
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/on-blur/on-blur.directive.js